import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'

/**
 * <DeleteShowDialog show onDeleteShow = {item} onCancel = {} />
 */

class DeleteShowDialog extends Component {

	render() {

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Удалить предмет
			</DialogTitle>

			<DialogContent>
				Вы уверены, что ходите удалить шоу &laquo;{this.props.show.name}&raquo;?
			</DialogContent>

			<DialogActions>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDeleteShow === "function") {
							this.props.onDeleteShow(this.props.show)
						}
					}}
				>Удалить</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default DeleteShowDialog
